// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1FXWD","log":"ModalInventoryLogs_log__1WQD8","date":"ModalInventoryLogs_date__37JZM","userName":"ModalInventoryLogs_userName__1huFN"};